import { render, staticRenderFns } from "./BiobankExplorerContainer.vue?vue&type=template&id=1b16d091&"
import script from "./BiobankExplorerContainer.vue?vue&type=script&lang=js&"
export * from "./BiobankExplorerContainer.vue?vue&type=script&lang=js&"
import style0 from "./BiobankExplorerContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports